import { Amplify } from 'aws-amplify';

// The configuration below must reflect the settings of the corresponding Cognito identity and user pools in AWS.
// See https://docs.amplify.aws/lib/client-configuration/configuring-amplify-categories/q/platform/js/#scoped-configuration.
export const amplifyConfiguration = {
  ssr: true,
  aws_project_region: process.env.NEXT_PUBLIC_AWS_REGION || 'us-east-1',
  aws_cognito_identity_pool_id:
    process.env.NEXT_PUBLIC_COGNITO_IDENTITY_POOL_ID ||
    'us-east-1:046bbc6e-15c2-424a-b1d9-2f2ba1d9f33e',
  aws_cognito_region: process.env.NEXT_PUBLIC_AWS_REGION || 'us-east-1',
  aws_user_pools_id:
    process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID || 'us-east-1_m9dFBSFZ9',
  aws_user_pools_web_client_id:
    process.env.NEXT_PUBLIC_COGNITO_WEB_CLIENT_ID ||
    '1v3italhs4r28i2ai0lkflh9pa',
  oauth: {
    domain:
      process.env.NEXT_PUBLIC_COGNITO_WEB_CLIENT_DOMAIN ||
      'loveverystaging.auth.us-east-1.amazoncognito.com',
    scope: [
      'openid',
      'profile',
      'email',
      // 'aws.cognito.signin.user.admin',
      'phone',
    ],
    redirectSignIn: `https://${process.env.VANITY_DOMAIN}/account/user`,
    redirectSignOut: `https://${process.env.VANITY_DOMAIN}`,
    responseType: 'code',
  },
  aws_cognito_username_attributes: [],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  cookieStorage: {
    // Use a leading period such as ".yourdomain.net" to cover subdomains of a parent domain.
    // This is how authentication state can be maintained across subdomains using Amplify/Cognito.
    domain:
      process.env.NODE_ENV === 'development'
        ? 'localhost'
        : `.${process.env.NEXT_PUBLIC_BACKEND_DOMAIN}` || '.lovery-stage.com',
    secure: false,
    expires: 365,
  },
  federationTarget: 'COGNITO_USER_POOLS',
};

Amplify.configure(amplifyConfiguration);
